<template>
  <!-- 个人中心 -->
  <div class="user-container">
    <!-- <van-nav-bar title="个人中心" /> -->
    <!-- 用户信息 -->
    <div class="user-card">
      <van-cell class="user-card-cell">
        <template #icon>
          <img class="avatar" :src="avatar" />
          <!-- file 选择框 -->
          <!-- 视觉上隐藏，但是标签还在DOM树上，还可以触发功能，所以用v-show不用v-if -->
<!--          <input type="file" ref="iptFile" v-show="false" accept="image/*" @change="onFileChange" />-->
        </template>
        <template #title>
          <div class="userInfo">
            <!-- <span class="user-desc">{{ user&&user.nickName }} {{ user&&user.userName }}</span> -->
            <span class="user-desc">{{ user.nickName }}</span>
          </div>
        </template>
      </van-cell>
    </div>
    <!-- 其他功能 -->
    <van-cell-group class="action-card">
      <!-- <van-cell icon="bar-chart-o" title="图表中心" is-link to="/echarts" /> -->
      <van-cell icon="comment-o" title="意见建议" is-link to="/comment_list" />
    </van-cell-group>

      <div style="margin: 220px 16px 16px 16px">
        <van-button
          round
          block
          @click="logout"
          type="primary"
          native-type="submit"
          class="exit-submit"
          :loading="isLoading"
          loading-text="正在退出登录..."
          :disabled="isLoading"
          >退出登录</van-button
        >
      </div>
  </div>
</template>

<script>
import { clearLogin } from '@/utils/token'
import { userProfileAPI, loginOut } from '@/api/index.js'
import { Notify, Toast } from 'vant'
export default {
  data() {
    return {
      alert_show: false, // 弹窗显示与隐藏
      user: { nickName: "管理员" }, // 用户对象
      avatar: require('@/assets/images/user/default.png'), // 用户头像
      isLoading: false
    }
  },
  async created() {
    // // 获取当前用户信息
    // const res_user = await userProfileAPI()
    // console.log('当前用户', res_user)
    // this.user = res_user.data.data
    this.user.nickName = localStorage.getItem("nickName")
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    window.addEventListener('popstate', () => {
      this.goBack();
    })
    // }
  },
  methods: {
    goBack() {
      this.$router.push({ path: 'home' })
    },
    // 提交方法，需要form整体通过验证才会触发
    async logout() {
      // 可以直接用values(收集参数名和值)
      this.isLoading = true
      const res = await loginOut({ userId: localStorage.getItem('loginId') })
      console.log(res)
      if (res.data.state !== 200) {
        Notify({ type: 'danger', message: res.data.message })
        return
      } else {
        clearLogin()
        await this.$router.replace({
          path: '/login'
        })
      }
      // 网络请求完成
      this.isLoading = false
    }
  },

  computed: {
    activeOrderStatusList: function () {
      return this.orderStatusList.filter((item) => {
        return item.id >= 0
      })
    }
  }
}
</script>
<style lang="less" scoped>
.user-container {
  background-image: url('@/assets/images/user/user_bg.png');
  background-size: 100% 100%;

  .user-card {
    margin: 0 10px 20px;
    padding-top: 50px;
    border-radius: 8px;
    height: 190px;
    width: auto;

    .user-card-cell {
      // position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      // color: #ffffff;
      padding: 10px auto;
      // border-radius: 8px;
      &::after {
        display: none;
      }
      .avatar {
        display: block;
        width: 100px;
        height: 100px;
        background-color: #ffffff;
        border-radius: 50%;
        z-index: 1;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        object-fit: cover;
      }
      .van-cell__title {
        width: 100%;
      }
      .userInfo {
        position: relative;
        top: -30px;
        width: 90%;
        background-color: #ffffff;
        border-radius: 8px;
        padding-top: 45px;
        padding-bottom: 15px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        text-align: center;
        // box-shadow: 2px 2px 4px 2px #ddd;
        box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
        .user-desc {
          display: block;
          text-align: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #121212;
          line-height: 23px;
          font-style: normal;
          text-transform: none;
        }
        .alias {
          font-size: 14px;
          color: #999;
          display: block;
          text-align: center;
        }
      }
    }
  }
  .my-order {
    background: #fff;
    margin: 20px 10px;
    padding: 8px;
    border-radius: 8px;
    .my-order-title {
      font-size: 14px;
      line-height: 16px;
      border-left: 5px solid #3857eb;
      margin: 5px;
      padding-left: 8px;
      display: flex;
      justify-content: space-between;
      a {
        color: #646566;
      }
    }
    .van-grid-item {
      /deep/ .van-grid-item__text {
        font-size: 14px;
      }
      /deep/ .van-grid-item__content {
        background: transparent;
      }
      /deep/ .van-icon__image {
        width: 50px;
        height: 50px;
      }
    }
  }
  /deep/ .van-cell-group{
    background-color:none;
  }
  .action-card {
    .van-icon:before {
      color: #3857eb;
      font-size: 20px;
    }
    .van-cell__title {
      margin-left: 10px;
    }
  }
.exit-submit{
  height: 40px;
  background: #3555EE;
  border-radius: 4px 4px 4px 4px;
}
}
</style>
